(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/custom-texts.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/custom-texts.js');
"use strict";


const customTexts = {
  svstrissadventskalender150y24: {
    autoCorrect: {
      title: 'Vill du verkligen rätta hela kalendern?',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Alla luckor öppnas och kalendern kontrolleras för vinst.',
        align: svs.components.dialog.message.align.CENTER
      }, {
        type: svs.components.dialog.message.TEXT,
        text: '<b>OBS: kan inte ångras!</b>',
        align: svs.components.dialog.message.align.CENTER
      }],
      actionTitle: 'Rätta hela kalendern',
      cancelTitle: 'Avbryt'
    },
    close: {
      title: 'Vill du fortsätta senare?',
      message: demo => [{
        type: svs.components.dialog.message.TEXT,
        text: demo ? ' ' : 'Du hittar din kalender under Mina spel och kan när som helst fortsätta öppna luckor.',
        align: svs.components.dialog.message.align.CENTER
      }],
      actionTitle: 'Fortsätt senare',
      cancelTitle: 'Avbryt'
    }
  },
  svstrissadventskalender150y22: {
    autoCorrect: {
      title: 'Vill du verkligen rätta hela kalendern?',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Alla luckor öppnas och kalendern kontrolleras för vinst.',
        align: svs.components.dialog.message.align.CENTER
      }, {
        type: svs.components.dialog.message.TEXT,
        text: '<b>OBS: kan inte ångras!</b>',
        align: svs.components.dialog.message.align.CENTER
      }],
      actionTitle: 'Rätta hela kalendern',
      cancelTitle: 'Avbryt'
    },
    close: {
      title: 'Vill du fortsätta senare?',
      message: demo => [{
        type: svs.components.dialog.message.TEXT,
        text: demo ? ' ' : 'Du hittar din kalender under Mina spel och kan när som helst fortsätta öppna luckor.',
        align: svs.components.dialog.message.align.CENTER
      }],
      actionTitle: 'Fortsätt senare',
      cancelTitle: 'Avbryt'
    }
  },
  svstriss100campaign50y26w32: {
    autoCorrect: {
      title: 'Du har inte spelat färdigt lotten',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Det finns fortfarande delar som inte är skrapade. Om du väljer “Kontrollera vinst” skrapas resten av lotten och rättas sedan automatiskt.',
        align: svs.components.dialog.message.align.CENTER
      }],
      actionTitle: 'Kontrollera vinst',
      cancelTitle: 'Spela färdigt'
    }
  },
  default: {
    autoCorrect: {
      title: 'Vill du verkligen rätta hela spelet?',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: ' ',
        align: svs.components.dialog.message.align.CENTER
      }, {
        type: svs.components.dialog.message.TEXT,
        text: '<b>OBS: kan inte ångras!</b>',
        align: svs.components.dialog.message.align.CENTER
      }],
      actionTitle: 'Rätta hela spelet',
      cancelTitle: 'Avbryt'
    },
    close: {
      title: 'Vill du avsluta spelet?',
      message: demo => [{
        type: svs.components.dialog.message.TEXT,
        text: demo ? ' ' : 'Du hittar dina köpta lotter i Mina spel',
        align: svs.components.dialog.message.align.CENTER
      }],
      actionTitle: 'Avsluta spel',
      cancelTitle: 'Avbryt'
    }
  }
};
const confirmClose = (type, demo) => {
  var _customTexts$type;
  const _ref = ((_customTexts$type = customTexts[type]) === null || _customTexts$type === void 0 ? void 0 : _customTexts$type.close) || customTexts.default.close,
    title = _ref.title,
    message = _ref.message,
    cancelTitle = _ref.cancelTitle,
    actionTitle = _ref.actionTitle;
  return {
    title,
    message: message(demo),
    cancelTitle,
    actionTitle
  };
};
const autoCorrect = type => {
  var _customTexts$type2;
  return ((_customTexts$type2 = customTexts[type]) === null || _customTexts$type2 === void 0 ? void 0 : _customTexts$type2.autoCorrect) || customTexts.default.autoCorrect;
};
setGlobal('svs.ticketgames.ticketUtility.utils.customTexts', {
  confirmClose,
  autoCorrect
});

 })(window);